import React, { useState, useEffect } from "react";

const Slider = () => {
  const images = [
    // "./images/pic-3.jpeg",
    "./images/slider/slider-1.png",
    "./images/slider/slider-2.png",
    // "./images/pic-2.jpeg",
    // "./images/pic-4.jpeg"
    // "./images/pic-6.jpeg"
  ];

  const [current, setCurrent] = useState(0);

  // Auto-play (slow down here)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 6000);  // ⬅ Change this value (6000 = 6 seconds)

    return () => clearInterval(interval);
  }, [images.length]);

  const nextSlide = () => {
    setCurrent((current + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrent((current - 1 + images.length) % images.length);
  };

  return (
    <div className="slider" style={{ width: "100%"}}>
      <button className="prev" onClick={prevSlide}>❮</button>

      <img
        src={images[current]}
        alt="Slider"
        className="slide-image"
        style={{ width: "100%" }}
      />

      <button className="next" onClick={nextSlide}>❯</button>
    </div>
  );
};

export default Slider;
